import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateTransform'
})
export class DateTransformPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (typeof value === 'number' ) {
      if (args && (args === 'day month')) {
        return moment.unix(value / 1000).utc().format('D MMM').toUpperCase();
      } else if (args && (args === 'hour')) {
        return moment.unix(value / 1000).utc().format('HH:mm');
      } else if (args && (args === 'week month')) {
        return moment.unix(value / 1000).utc().format('WW');
      } else if (args === undefined) {
      } else if (args && (args === 'month')) {
        return moment.unix(value / 1000).utc().format('MMMM');
      } else if (args === undefined) {
        return moment.unix(value / 1000).utc().format('DD/MM/YYYY HH:mm:ss');
      }
    }
    return value;
  }

}
